export default __webpack_public_path__ + "static/media/drag-drop.a63722b8.JPG";